import type { SalesQualification } from '../../../types/admin';

export const qualificationQuestions = [
  ['interest_reason', 'What got you interested in checking us out?', 'Why ApexOS'],
  ['current_tools', 'What tools are you using now?', 'Current tools'],
  ['work_type', 'What type of work do you do?', 'Type of work'],
  ['frustrations', 'What are your main frustrations?', 'Main frustrations'],
  ['is_owner', 'Are you the owner?', 'Owner'],
  ['time_in_business', 'How long have you been in business?', 'Time in business'],
  ['priorities', 'What are your priorities for a new system?', 'Priorities'],
  ['integrations', 'Any integrations needed?', 'Integrations'],
  ['user_count', 'How many users?', 'Users needed'],
  ['timeline', 'What is your timeline?', 'Timeline'],
] as const;

export function qualificationCount(answers: SalesQualification) {
  return qualificationQuestions.filter(([key]) => {
    const value = answers[key]?.trim() || '';
    if (key === 'is_owner') return value === 'yes' || value === 'no';
    if (key === 'user_count') return /^\d+$/.test(value) && Number(value) >= 1 && Number(value) <= 100000;
    return !!value;
  }).length;
}
